import type { UUID } from '@/types/Id'

export const pursuitSchemasQueryKeys = {
  all: () => ['pursuit_schemas'] as const,
  organization: (args: { orgId: UUID | '' }) =>
    ['pursuit_schemas', args.orgId] as const,
  latest: (args: { orgId: UUID | '' }) =>
    ['pursuit_schemas', args.orgId, 'latest'] as const,
  schema: (args: { schemaId: UUID | '' }) =>
    ['pursuit_schemas', 'schema', args.schemaId] as const,
}
